module.exports = __webpack_public_path__ + "img/back4.674ae8b2.jpg";